import { GetBestContentsQuery } from '@diritto/common/api/RelayContentApi';
import { BEST_PAGE_ITEM_COUNT, BestType, MAX_BEST_CONTENTS_COUNT } from '@diritto/common/best/constants';
import { ContentRankListRelayResponseDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { QueryClient, useInfiniteQuery } from '@tanstack/react-query';
import { RelayContentApi } from 'api/ApiHelper';
import { AxiosRequestConfig } from 'axios';
import { relayQueryKey } from 'queries/relay/queryKey';

const getNextPageParam = (lastGroup: ContentRankListRelayResponseDto, allGroups: ContentRankListRelayResponseDto[]) => {
  if ((lastGroup.contentIds?.length ?? 0) < BEST_PAGE_ITEM_COUNT) {
    return undefined;
  }
  const currentCount = allGroups.reduce((acc, current) => acc + (current.contentIds?.length ?? 0), 0);
  return currentCount <= MAX_BEST_CONTENTS_COUNT ? currentCount : undefined;
};

export const useGetRelayRankingContentsInfiniteQuery = (
  query: GetBestContentsQuery,
  bestType = BestType.Realtime,
  options?: AxiosRequestConfig,
) =>
  useInfiniteQuery({
    queryKey: relayQueryKey.bestList(bestType, query),
    queryFn: ({ pageParam = 0 }) =>
      RelayContentApi.getRankingContents(
        bestType,
        { offset: pageParam, limit: BEST_PAGE_ITEM_COUNT, ...query },
        options,
      ),
    initialPageParam: 0,
    getNextPageParam,
  });

export const prefetchRelayRankingContentsInfiniteQuery = (
  queryClient: QueryClient,
  options: AxiosRequestConfig,
  query: GetBestContentsQuery,
  bestType: BestType,
) =>
  queryClient.prefetchInfiniteQuery({
    queryKey: relayQueryKey.bestList(bestType, query),
    queryFn: ({ pageParam = 0 }) =>
      RelayContentApi.getRankingContents(
        bestType,
        { offset: pageParam, limit: BEST_PAGE_ITEM_COUNT, ...query },
        options,
      ),
    initialPageParam: 0,
    getNextPageParam,
  });
